/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductDetailCategory,
    AdminProductDetailCategoryFromJSON,
    AdminProductDetailCategoryFromJSONTyped,
    AdminProductDetailCategoryToJSON,
} from './AdminProductDetailCategory';
import {
    AdminProductDetailGroupSale,
    AdminProductDetailGroupSaleFromJSON,
    AdminProductDetailGroupSaleFromJSONTyped,
    AdminProductDetailGroupSaleToJSON,
} from './AdminProductDetailGroupSale';
import {
    AdminProductDetailImage,
    AdminProductDetailImageFromJSON,
    AdminProductDetailImageFromJSONTyped,
    AdminProductDetailImageToJSON,
} from './AdminProductDetailImage';
import {
    AdminProductDetailMarketplace,
    AdminProductDetailMarketplaceFromJSON,
    AdminProductDetailMarketplaceFromJSONTyped,
    AdminProductDetailMarketplaceToJSON,
} from './AdminProductDetailMarketplace';
import {
    AdminProductStatus,
    AdminProductStatusFromJSON,
    AdminProductStatusFromJSONTyped,
    AdminProductStatusToJSON,
} from './AdminProductStatus';
import {
    ProductConsistency,
    ProductConsistencyFromJSON,
    ProductConsistencyFromJSONTyped,
    ProductConsistencyToJSON,
} from './ProductConsistency';

/**
 * 
 * @export
 * @interface AdminProductDetail
 */
export interface AdminProductDetail {
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetail
     */
    asin?: string;
    /**
     * 
     * @type {AdminProductDetailCategory}
     * @memberof AdminProductDetail
     */
    category: AdminProductDetailCategory;
    /**
     * 
     * @type {ProductConsistency}
     * @memberof AdminProductDetail
     */
    consistency: ProductConsistency;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProductDetail
     */
    consistencyDetails?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetail
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetail
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetail
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetail
     */
    id: string;
    /**
     * 
     * @type {Array<AdminProductDetailImage>}
     * @memberof AdminProductDetail
     */
    images?: Array<AdminProductDetailImage>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetail
     */
    listingNumber: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetail
     */
    lowestResalePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetail
     */
    mSRP: number;
    /**
     * 
     * @type {Array<AdminProductDetailMarketplace>}
     * @memberof AdminProductDetail
     */
    marketplaces?: Array<AdminProductDetailMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetail
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetail
     */
    palletOrderID?: number;
    /**
     * 
     * @type {Array<AdminProductDetailGroupSale>}
     * @memberof AdminProductDetail
     */
    productGroupSale?: Array<AdminProductDetailGroupSale>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetail
     */
    purchasePrice: number;
    /**
     * 
     * @type {AdminProductStatus}
     * @memberof AdminProductDetail
     */
    status: AdminProductStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetail
     */
    updatedAt?: string;
}



export function AdminProductDetailFromJSON(json: any): AdminProductDetail {
    return AdminProductDetailFromJSONTyped(json, false);
}

export function AdminProductDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asin': !exists(json, 'asin') ? undefined : json['asin'],
        'category': AdminProductDetailCategoryFromJSON(json['category']),
        'consistency': ProductConsistencyFromJSON(json['consistency']),
        'consistencyDetails': !exists(json, 'consistencyDetails') ? undefined : json['consistencyDetails'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : json['deletedAt'],
        'description': json['description'],
        'id': json['id'],
        'images': !exists(json, 'images') ? undefined : ((json['images'] as Array<any>).map(AdminProductDetailImageFromJSON)),
        'listingNumber': json['listingNumber'],
        'lowestResalePrice': !exists(json, 'lowestResalePrice') ? undefined : json['lowestResalePrice'],
        'mSRP': json['mSRP'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminProductDetailMarketplaceFromJSON)),
        'name': json['name'],
        'palletOrderID': !exists(json, 'palletOrderID') ? undefined : json['palletOrderID'],
        'productGroupSale': !exists(json, 'productGroupSale') ? undefined : ((json['productGroupSale'] as Array<any>).map(AdminProductDetailGroupSaleFromJSON)),
        'purchasePrice': json['purchasePrice'],
        'status': AdminProductStatusFromJSON(json['status']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
    };
}

export function AdminProductDetailToJSON(value?: AdminProductDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asin': value.asin,
        'category': AdminProductDetailCategoryToJSON(value.category),
        'consistency': ProductConsistencyToJSON(value.consistency),
        'consistencyDetails': value.consistencyDetails,
        'createdAt': value.createdAt,
        'deletedAt': value.deletedAt,
        'description': value.description,
        'id': value.id,
        'images': !value.images ? undefined : ((value.images as Array<any>).map(AdminProductDetailImageToJSON)),
        'listingNumber': value.listingNumber,
        'lowestResalePrice': value.lowestResalePrice,
        'mSRP': value.mSRP,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminProductDetailMarketplaceToJSON)),
        'name': value.name,
        'palletOrderID': value.palletOrderID,
        'productGroupSale': !value.productGroupSale ? undefined : ((value.productGroupSale as Array<any>).map(AdminProductDetailGroupSaleToJSON)),
        'purchasePrice': value.purchasePrice,
        'status': AdminProductStatusToJSON(value.status),
        'updatedAt': value.updatedAt,
    };
}

